import type { MessageRef } from '@elara/domain/models/schemas/shortlist-schemas';

import { useContext } from 'react';

import { MessageContext } from '../chat/message-context.js';

/**
 * Hook to access messageRef from context
 */
export function useMessageRef(): MessageRef | undefined {
  return useContext(MessageContext).messageRef;
}

